import React from 'react';

import QuotaProductosClorox  from 'components/Tvendo/Sale/QuotaBPartner/Clorox/QuotaProductosClorox/List.js';

export default function () {
  return <QuotaProductosClorox  />;
}